<template>
    <loading :active.sync="sync"
             :is-full-page="fullPage"
             color="#23C426"
             blur="5px"
             :height="92"
             :width="92"
             :opacity="0.5"
             :z-index="999"
             loader="bars">
    </loading>
</template>

<script>
import Loading from 'vue-loading-overlay';
export default {
    name: "LoadingIndicator",
    components: {Loading},
    props: {
        sync: {
            type: Boolean,
            default: false
        },
        fullPage: {
            type: Boolean,
            default: false
        },
    }
}
</script>

<style scoped>

</style>
